// extracted by mini-css-extract-plugin
export default {"tooltip__wrap":"Tooltip_tooltip__wrap__oGyc8","left":"Tooltip_left__Vfe1O","top":"Tooltip_top__RmYhR","tooltip-box":"Tooltip_tooltip-box__rDQLm","bottom":"Tooltip_bottom__VJGaJ"};